class ProductCardCompare extends HTMLElement {
  static get observedAttributes(){ return ['product-handle','image-src','label']; }

  constructor(){
    super();
    this._handle = this.getAttribute('product-handle') || '';
    this._image  = this.getAttribute('image-src') || '';
    this._label  = this.getAttribute('label') || 'Compare Product';
    this._product_title = this.getAttribute('product-title') || '';
    this._pressed = false;
    this._onChange = this._onChange.bind(this);
    this._onCompareChange = this._onCompareChange.bind(this);
  }

  connectedCallback(){
    if (!this._rendered) { this._render(); this._rendered = true; }

    this._input = this.querySelector('input[type="checkbox"]');
    this._labelEl = this.querySelector('.product-item__compare_products');
    this._textEl  = this.querySelector('.product-item__compare_products__text');
    this._input?.addEventListener('change', this._onChange);

    window.addEventListener('compare_change', this._onCompareChange);
    this._sync();
  }

  disconnectedCallback(){
    this._input?.removeEventListener('change', this._onChange);
    window.removeEventListener('compare_change', this._onCompareChange);
  }

  attributeChangedCallback(n, _old, val){
    if (n === 'product-handle') { this._handle = val || ''; this._sync(); }
    if (n === 'image-src')      { this._image = val || ''; }
    if (n === 'label')          { this._label = val || 'Compare Product'; if (this._textEl) this._textEl.textContent = this._label; if (this._input) this._input.setAttribute('aria-label', this._label); }
  }

  _readHandles(){
    try{
      const raw = localStorage.getItem('compare:handles');
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : (Array.isArray(parsed?.handles) ? parsed.handles : []);
    } catch { return []; }
  }

  _sync(){
    const arr = this._readHandles();
    this._pressed = !!(this._handle && arr.includes(this._handle));
    if (this._input){
      this._input.checked = this._pressed;
      this._input.setAttribute('aria-checked', String(this._pressed));
    }
    this._labelEl?.classList.toggle('is-checked', this._pressed);
  }

  _onCompareChange(){
    this._sync();
  }

  _onChange(e){
    if (!this._handle) return;
    this._pressed = !!e.currentTarget.checked;
    e.currentTarget.setAttribute('aria-checked', String(this._pressed));
    if (this._pressed) {
      window.dispatchEvent(new CustomEvent('compare_product_added',  { detail:{ handle: this._handle, image: this._image, title: this._product_title } }));
    } else {
      window.dispatchEvent(new CustomEvent('compare_product_removed',{ detail:{ handle: this._handle } }));
    }
  }

  _render(){
    this.innerHTML = `
      <label class="product-item__compare_products">
        <input type="checkbox" role="checkbox" aria-checked="false" aria-label="${this._label}">
        <span class="product-item__compare_products__box" aria-hidden="true">
          <svg class="product-item__compare_products__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </span>
        <span class="product-item__compare_products__text">${this._label}</span>
      </label>
    `;
  }
}

customElements.define('product-card-compare', ProductCardCompare);
